/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconCalendarLeftArrow(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M11.031 10.143h-5.2M6.781 8.4 5.2 10.144l1.582 1.744"
      />
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        mask="url(#mask0_6657_154911)"
      >
        <path d="M14.125 15.375H1.875c-.69 0-1.25-.56-1.25-1.25v-11c0-.69.56-1.25 1.25-1.25h12.25c.69 0 1.25.56 1.25 1.25v11c0 .69-.56 1.25-1.25 1.25ZM3.25 3.125v-2.5M12.75.625v2.5M.625 5.25h14.75" />
      </g>
    </svg>
  );
}
